// "Debug the Real Path (Most 'Bugs' Are False Alarms)" — build-in-public RAG-debugging short.
// Cold Compute / Neon kit. ~105s @ 30fps.
//
// GROUNDED in a real event (2026-07): a deep audit of one 13-turn prod chat about
// EAKC's retrieval pipeline. Most flagged "issues" were FALSE ALARMS — the "grok"
// model mention was accurate/grounded, a grounding-check "error" was the check
// correctly flagging an unsupported claim, and an "in_progress" step was just the
// first half of a normal pair. The ONE real bug: the whole-system/architecture
// answer leaked internal [File Index: path|lines|lang] chunk-map markers into prose
// (often malformed) and coined fake [Knowledge Graph] citations. An 8-expert review
// caught that the FIRST fix was on the WRONG code path; the real leak came from the
// "codebase map" injection that pushes raw file-index headers straight into the
// prompt. The real fix rewrites those to a clean "File: <path>" BEFORE the model
// sees them, so it never copies them (live stream clean too, not just the saved
// answer). Verified on prod by pulling both chats from the DB: the exact same
// architecture question went from 4 stray markers / 9 fake citations / 25 broken
// fragments to 0 / 0 / 0. Only that validated before→after count is shown as proof.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames; contiguous.
export const SCENE = {
  hook: { start: 0, duration: 150 }, //          0:00–0:05  audited one chat — most "bugs" were false alarms
  falseAlarms: { start: 150, duration: 540 }, //  0:05–0:23  three flags that were fine
  realBug: { start: 690, duration: 450 }, //      0:23–0:38  the one real bug: leaked chunk-map markers
  wrongFix: { start: 1140, duration: 420 }, //    0:38–0:52  the first fix was on the wrong code path
  realFix: { start: 1560, duration: 480 }, //     0:52–1:08  rewrite headers before the model sees them
  verified: { start: 2040, duration: 450 }, //    1:08–1:23  verified on prod: 4/9/25 → 0/0/0
  lessons: { start: 2490, duration: 420 }, //     1:23–1:37  verify first · trace the real path
  outro: { start: 2910, duration: 240 }, //       1:37–1:45
} as const;

export const TOTAL_DURATION = 3150; // 105s — verified contiguous sum below
// hook150 + falseAlarms540 + realBug450 + wrongFix420 + realFix480 + verified450 + lessons420 + outro240 = 3150 (105s)

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
